// extracted by mini-css-extract-plugin
export default {"coverVideoError":"cover-video-player_coverVideoError__muSfL"};